/* globals $ */
(function() {
    'use strict';

    var progress_bar_timer = 0;

    window.ProgressBar = function(params) {
        this.completion = 0;
        this.timer = 0;
        this.max_increase_speed = params.max_increase_speed ? params.max_increase_speed : 4;
        this.min_increase_speed = params.min_increase_speed ? params.min_increase_speed : 2;
        this.interval = 1000;
        this.increments = 1;
        this.bar_selector = params.bar_selector;
        this.txt_selector = params.txt_selector;
        this.active = true;
        this.completeCallback = params.completeCallback ? params.completeCallback : function() {
        };
        this.progress_txt = params.progress_txt ? params.progress_txt : {};

        this.increaseProgressBar = function() {
            if (!this.active) {
                return;
            }

            var increment_by = Math.random() * (this.max_increase_speed - this.min_increase_speed) + this.min_increase_speed;
            this.completion = Math.min(this.completion + increment_by, 100);

            //display the new percentage
            if ($(this.bar_selector).length) {

                $(this.bar_selector).css('width', parent.completion + '%');

                parent.timer = setTimeout(function() {
                    if (parent.completion < 100) {
                        parent.increaseProgressBar();
                    } else {
                        parent.completeCallback();
                    }
                }, parent.interval);

            }

            // display the txt
            this._displayLoadingTxt();
        };

        this.changeSpeed = function(min, max) {
            this.min_increase_speed = min;
            this.max_increase_speed = max;
        };

        this.stop = function() {
            this.active = false;
        };

        this._displayLoadingTxt = function() {
            if ($(this.txt_selector).length) {
                var message = '';
                for (var x in this.progress_txt) {
                    if (x <= this.completion) {
                        message = this.progress_txt[x];
                    }
                }
                $(this.txt_selector).html(message);
            }
        };

        this.clearTimeout = function() {
            // clear previous progress bar
            clearTimeout(this.timer);
            this.completion = 0;
        };

        // init()
        var parent = this;

        this.timer = setTimeout(function() {
            parent.increaseProgressBar();
        }, this.interval);

        this._displayLoadingTxt();
        $(this.bar_selector).css('width', 0);
    };
})();